<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('blogTitle') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle4')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <div class="title-line">
      <h1>{{ $t('artTitle4') }}</h1>
    </div>
    <p class="mt-5">{{ $t('artText4-1') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat-A-New-Player-at-Home-Design-Software-Market.webp`"
      :alt="'altImageDefault'"
    />
    <h2 class="mt-0">{{ $t('artText4-2') }}</h2>
    <p>{{ $t('artText4-3') }}</p>
    <h2 class="mt-5">{{ $t('artText4-4') }}</h2>
    <p>{{ $t('artText4-5') }}</p>
    <ul>
      <li>{{ $t('artText4-5-li-1') }}</li>
      <li>{{ $t('artText4-5-li-2') }}</li>
      <li>{{ $t('artText4-5-li-3') }}</li>
    </ul>
    <h2 class="mt-0">{{ $t('artText4-6') }}</h2>
    <ul>
      <li>{{ $t('artText4-6-li-1') }}</li>
      <li>{{ $t('artText4-6-li-2') }}</li>
      <li>{{ $t('artText4-6-li-3') }}</li>
      <li>{{ $t('artText4-6-li-4') }}</li>
      <li>{{ $t('artText4-6-li-5') }}</li>
    </ul>
    <img
      :src="`${staticUrl}/images/DreamFlat-A-New-Player-at-Home-Design-Software-Market-1.webp`"
      :alt="'altImageDefault'"
      class="mt-5"
    />
    <p>{{ $t('artText4-7') }}</p>
    <h2>{{ $t('artText4-8') }}</h2>
    <p>{{ $t('artText4-9') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle3')}`,
  ogTitle: `${t('artSeoTitle3')}`,
  description: `${t('artSeoDesc3')}`,
  ogDescription: `${t('artSeoDesc3')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
